import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KioskListing extends Component {
    render() {
        return(
            <div className="kiosk__listing">
                <div className="kiosk__content">
                    {this.props.children}
                </div>
                <div className="kiosk__background-image">
                </div>
            </div>
        )
    }
}

KioskListing.propTypes = {
}

export default KioskListing

